import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.less';
import tools from '../../../utils/tools';

const propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
};

class VideoView extends Component {
  onClose = () => {
    const { history } = this.props;
    history.goBack();
  };

  render() {
    const fileUrl = tools.getQueryString('fileUrl');
    return (
      <div className={styles.playerBox} style={{ width: `${window.innerWidth}px`, height: `${window.innerHeight}px` }}>
        <video width={window.innerWidth} className={styles.priviewVideo} playsinline preload="auto" controls src={fileUrl} height="auto">
          <track kind="captions" />
        </video>
        <div className={styles.close} onClick={this.onClose} role="button" tabIndex={0}>
          关 闭
        </div>
      </div>
    );
  }
}

VideoView.propTypes = propTypes;

export default VideoView;
